<template>
  <Sidebar class="sidebar" :style="{ width: sidebarwidth }">
    <!-- {{itemId}} -->
    <template #header>
      <div class="sidebar-header-content w-100">
        <p class="bold-heading">Item Details</p>
        <i @click="$emit('close')" class="pi pi-times pt-3"></i>
      </div>
    </template>
    <div class="d-flex">
      <div class="Details-container" :style="{ width: sidebarMinwidth }">
        <b-container fluid>
          <b-row>
            <b-col cols="3">
              <div class="I-img">
                <img src="../../../../../assets/Img/icons/itemimg.png" alt="" />
              </div>
            </b-col>
            <b-col cols="9">
              <p class="tablet-id">{{ ItemData.ProductId }}</p>
              <p class="tablet-name">{{ ItemData.ItemName }}</p>
              <b-row>
                <b-col cols="3" class="pe-0">
                  <p class="txt-blue-sm">Request</p>
                </b-col>
                <b-col cols="9">
                  <p class="txt-blue-sm">Record a consumption</p>
                </b-col>
                <b-col cols="8">
                  <p class="txt-blue-sm">Check Availability</p>
                </b-col>
                <b-col cols="8">
                  <p class="txt-blue-sm" @click="stockAdjust">Adjust stock</p>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <p class="sub-heading">Pricing</p>
          <Pricing :itemdata="ItemData" />

          <p class="sub-heading">Availability</p>
          <div class="availabiltybar mb-3">
            <ProgressBar :value="ItemData.AvlCount"></ProgressBar>
          </div>
          <b-row class="pe-0">
            <b-col cols="4" class="ps-0">
              <div class="Avail-box">
                <div class="d-flex align-items-center">
                  <div class="Avail-select"></div>
                  <p class="Avail-content">Available Qty</p>
                </div>
                <p class="Avail-count1 mt-1">

                  {{
                    Math.max(0, (ItemData.StockInHand - (ItemData.PickedQty + ItemData.InTransist))).toFixed(2)
                  }}
                </p>
              </div>
            </b-col>
            <b-col cols="4" class="ps-0">
              <div class="Avail-box">
                <div class="d-flex">
                  <div class="Avail-select1"></div>
                  <p class="Avail-content">Daily Avg. Consumption</p>
                </div>
                <p class="Avail-count">
                  {{ ItemData.AvgDailyConsumption }}
                </p>
              </div>
            </b-col>
            <b-col cols="4" class="ps-0">
              <div class="Avail-box">
                <div class="d-flex">
                  <div class="Avail-select"></div>
                  <p class="Avail-content">Reorder Level</p>
                </div>
                <p class="Avail-count">
                  {{ ItemData.ReOrderLevel }}
                </p>
              </div>
            </b-col>
          </b-row>
          <div class="itemlinkreqbg">
            <img src="../../../../../assets/Img/icons/errorbluefill.svg" alt="" />
            <p>
              <span class="itemcount">{{ ItemData.POItemCount }}</span>Items part of {{ ItemData.PoId }} & {{
                ItemData.POCount }} others
            </p>
          </div>
          <div class="itemlinkreqbg">
            <img src="../../../../../assets/Img/icons/errorbluefill.svg" alt="" />
            <p>
              <span class="itemcount">{{ ItemData.ItemCount }}</span>Items part of {{ ItemData.RequestCount }} requests
            </p>
          </div>
          <div class="itemlinkstorebg">
            <img src="../../../../../assets/Img/icons/warningredfill.svg" alt="" />

            <p>
              <span class="itemcount me-0">{{ ItemData.ExpStock }}</span>
              quantity that are about to expire in &#60; 1 month
            </p>
          </div>
          <p class="sub-heading mt-3">Last 7 days consumption</p>
          <div class="chartbar">
            <GChart type="ColumnChart" :options="options" :data="Chartdata" :resizeDebounce="100"
              style="display: block" />
          </div>

          <!-- <div class="d-flex align-items-center justify-content-between my-5">
            <h6 class="bold-heading">Item Breakup</h6>
            <h6 class="high-val" @click="BreakUpDetails">View Details</h6>
          </div> -->
          <div class="d-flex flex-column my-5">
            <div class="d-flex align-items-center justify-content-between">
              <h6 class="bold-heading">Item Breakup</h6>
              <h6 class="high-val" @click="BreakUpDetails">View Details</h6>
            </div>
            <span class="light-txt mt-2">Last 5 Transaction</span>
          </div>
          <b-row>
            <NormalTable :rowHover="true" filterDisplay="menu" responsiveLayout="scroll" :columns="ItemBreakUPHeaders"
              v-model:value="Batchitems">
              <template v-slot:ExpiryDateslot="{ data }">
                <div v-if="data.ExpiryDate && data.ExpiryDate != '01 Jan 1900'"
                  :style="getExpiryDateStyle(data.ExpiryDate)">
                  {{ data.ExpiryDate }}
                  <div class="expiry-message">{{ getExpiryMessage(data.ExpiryDate) }}</div>
                </div>
                <div v-else>
                  {{ " - " }}
                </div>
              </template>
              <template v-slot:colour="{ data }">
                <span :class="{
                  'free-item': data.IsFreeItem === 1,
                  'Block-item': data.IsBlock === 1,
                }">
                  {{ data.BarCode }}
                  <span v-if="data.IsBlock === 1">(Blocked)</span>
                  <span v-else-if="data.IsFreeItem === 1">(promo)</span>
                </span>
              </template>
              <template v-slot:Batchnoslot="{ data }">
                <span v-if="data.Batchno != ''">
                  {{ data.Batchno }}
                </span>
                <span v-else>
                  {{ " - " }}
                </span>
              </template>
              <template v-slot:StockInHandslot="{ data }">
                <span>

                  {{
                    Math.max(0, (data.StockInHand - (data.PickedQty + data.InTransist))).toFixed(2)
                  }}
                </span>
              </template>
            </NormalTable>
          </b-row>

          <b-row class="">
            <b-row>
              <b-col>
                <div class="d-flex">
                  <img src="../../../../../assets/Img/icons/downsymbol.svg" alt="" class="down-symbol" />
                  <h6 class="bold-heading mt6 ms-1">Item Details</h6>
                </div>
              </b-col>
            </b-row>
          </b-row>
          <b-row>
            <b-col>
              <ItemDetails :itemId="itemid" />
            </b-col>
          </b-row>

          <!-- <b-row class="my-3">
                <b-col>
                    <div class="d-flex mt-3">
                        <img src="../../../../assets/Img/icons/downsymbol.svg" alt="" class="down-symbol">
                        <h6 class="bold-heading mt6 ms-1">Rack-Box Mapping</h6>
                    </div>
                </b-col>
            </b-row> -->
          <!-- <b-row>
                <b-col>
                    <RackBoxMapping />
                </b-col>
            </b-row> -->
          <!-- <div class="d-flex my-5 dtl-button">
            <b-row>
           
                    <bcol lg="3" md="3" sm="3" cols="6">
                        <b-button type="button" @clcik="ViewDetails">View Details</b-button>
                          
                    </bcol>
            </b-row>
            </div> -->
          <div class="d-flex align-items-center justify-content-between my-5">
            <h6 class="bold-heading">Stock Adjust</h6>
            <h6 class="high-val" @click="ViewDetails">View Details</h6>
          </div>
          <table class="table table-striped stock-table">
            <thead>
              <tr>
                <th>
                  {{ $t("storetabdetails.itemdetailsrightsidebar.Date&Time") }}
                </th>
                <th>
                  {{ $t("storetabdetails.itemdetailsrightsidebar.Reason") }}
                </th>
                <th>
                  {{ $t("storetabdetails.itemdetailsrightsidebar.AdjustQty") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in items" :key="index">
                <td>{{ item.DocDate }}</td>
                <td>{{ item.ReasonName }}</td>
                <td>{{ item.AdjQty }}</td>
              </tr>
            </tbody>
          </table>
        </b-container>
      </div>
      <div class="form stock-form" v-if="stockForm">
        <b-form @submit.prevent="SubmitStocAdjustment">
          <p class="bold-heading">
            {{ $t("StockAdjustment.StockAdjustment") }}
          </p>
          <b-container fluid>
            <b-row>
              <b-col lg="8" md="8" sm="6" cols="6">
                <div class="field mb-3">
                  <Datepicker class="date" :label="$t('StockAdjustment.Date')" name="Doc Date" id="Doc Date"
                    v-model="StockAdjData.DocDate" :showButtonBar="true" :rules="{ required: true }"
                    :required-icon="true" />
                </div>
              </b-col>
              <b-col lg="12" md="12" sm="12" cols="12">
                <div class="field mb-3" v-if="ItemDetails?.['BatchRequired']">
                  <label>{{ $t("item.batchno") }}</label>
                  <AutoCompleteCustom v-model="StockAdjData.Batch" :items="itemsBatchNoList" name="Batch" id="Batch"
                    @keyup="filterBatchNo(StockAdjData.Batch)" class="autoItem" @item-select="Loadloaction"
                    :disabled="false" />
                </div>
                <div class="field mb-3" v-else>
                  <CustomDropDown v-model="StockAdjData.BarCode" :items="itemsBarCodeNoList" :label="$t('item.BarCode')"
                    name="BarCode" id="BarCode" :required-icon="false" :rules="{ required: false }"
                    @update:modelValue="Loadloaction" />

                </div>

                <!-- {{itemsBatchNoList}} -->
              </b-col>
              <b-col lg="12" md="12" sm="12" cols="12">
                <div class="field mb-3">
                  <CustomDropDown v-model="StockAdjData.Brand" :items="StockAdjOpData.BrandOption"
                    :label="$t('StockAdjustment.Brand')" name="Brand" id="Brand" :required-icon="false"
                    :rules="{ required: false }" @update:modelValue="" :disabled="FieldDisable.Brand" />
                </div>
              </b-col>

              <b-col lg="12" md="12" sm="12" cols="12">
                <div class="field mb-3">
                  <CustomDropDown v-model="StockAdjData.ModelNumber" :items="StockAdjOpData.ModelNumberOption"
                    :label="$t('StockAdjustment.ModelNumber')" name="ModelNumber" id="ModelNumber"
                    :required-icon="false" :rules="{ required: false }" @update:modelValue=""
                    :disabled="FieldDisable.ModelNumber" />
                </div>
              </b-col>

              <b-col lg="12" md="12" sm="12" cols="12">
                <div class="field mb-3">
                  <CustomDropDown v-model="StockAdjData.Size" :items="StockAdjOpData.SizeOption"
                    :label="$t('StockAdjustment.Size')" name="Size" id="Size" :required-icon="false"
                    :rules="{ required: false }" @update:modelValue="" :disabled="FieldDisable.Size" />
                </div>
              </b-col>
              <b-col lg="12" md="12" sm="12" cols="12">
                <div class="field mb-3">
                  <CustomDropDown v-model="StockAdjData.RoomId" :items="StockAdjOpData.RoomOption"
                    :label="$t('StockAdjustment.Room')" name="Room" id="Room" :required-icon="false"
                    :rules="{ required: false }" @update:modelValue="getrackbyroomid()" :disabled="FieldDisable.Room" />
                </div>
              </b-col>
              <b-col lg="12" md="12" sm="12" cols="12">
                <div class="field mb-3">
                  <CustomDropDown v-model="StockAdjData.RackId" :items="StockAdjOpData.RackOption"
                    :label="$t('StockAdjustment.Rack')" name="Rack" id="Rack" :required-icon="false"
                    :rules="{ required: false }" @update:modelValue="getrowbyrackid()" :disabled="FieldDisable.Rack" />
                </div>
              </b-col>
              <b-col lg="12" md="12" sm="12" cols="12">
                <div class="field mb-3">
                  <CustomDropDown v-model="StockAdjData.RowId" :items="StockAdjOpData.RowOption"
                    :label="$t('StockAdjustment.Row')" name="Row" id="Row" :required-icon="false"
                    :rules="{ required: false }" @update:modelValue="getboxbyrowid()" :disabled="FieldDisable.Row" />
                </div>
              </b-col>
              <b-col lg="12" md="12" sm="12" cols="12">
                <div class="field mb-3">
                  <CustomDropDown v-model="StockAdjData.BoxId" :items="StockAdjOpData.BoxOption"
                    :label="$t('StockAdjustment.Box')" name="Box" id="Box" :required-icon="false"
                    :rules="{ required: false }" :disabled="FieldDisable.Box" />
                </div>
              </b-col>
              <b-col lg="6" md="6" sm="6" cols="6">
                <div class="field mb-3">
                  <CustomDropDown v-model="StockAdjData.UOM" :items="StockAdjOpData.UOMoption"
                    @update:modelValue="UOMOnChange" :label="$t('StockAdjustment.UOM')" name="UOM" id="UOM"
                    :required-icon="false" :rules="{ required: false }" :disabled="FieldDisable.UOM" />
                </div>
              </b-col>
              <b-col lg="6" md="6" sm="6" cols="6">
                <div class="field mb-3">
                  <TextInput v-model="StockAdjData.StockInHand" name="AvailQty" id="AvailQty"
                    :label="$t('StockAdjustment.AvailableQty')" :rules="{ required: false }" :required-icon="false"
                    :disabled="true" />
                </div>
              </b-col>

              <b-col lg="6" md="6" sm="6" cols="6">
                <div class="field mb-3">
                  <InputNumber v-model="StockAdjData.Quantity" name="Quantity" id="Quantity"
                    :label="$t('StockAdjustment.Quantity')" :rules="{ required: true }" :required-icon="true"
                    :showButtons="true" inputId="horizontal-buttons" mode="decimal" buttonLayout="horizontal"
                    @update:model-value="QtyChange" />
                </div>
              </b-col>
              <b-col lg="6" md="6" sm="6" cols="6">
                <div class="field mb-3">
                  <Datepicker class="date" :label="$t('StockAdjustment.ExpDate')" name="Expiry Date" id="Expiry Date"
                    v-model="StockAdjData.ExpiryDate" :showButtonBar="true"
                    v-if="ItemDetails?.['ExpiryDtRequired'] && DispExp" :rules="{ required: true }"
                    :required-icon="true" :disabled="FieldDisable.ExpiryDate" />
                </div>
              </b-col>
              <b-col lg="12" md="12" sm="12" cols="12">
                <div class="field mb-3">
                  <CustomDropDown v-model="StockAdjData.StockReasonId" :items="StockAdjOpData.ReasonOption"
                    :label="$t('StockAdjustment.Reason')" name="Reason" id="Reason" :required-icon="false"
                    :rules="{ required: false }" />
                </div>
              </b-col>
              <b-col lg="6" md="6" sm="6" cols="6">
                <Cancel @canclebtn="$emit('cancel')" />
              </b-col>
              <b-col lg="6" md="6" sm="6" cols="6">
                <Save type="submit" label="Apply" />
              </b-col>
            </b-row>
          </b-container>
        </b-form>
      </div>
      <div v-if="showTable" class="itemsetailtable">
        <Tableview :value="items1" :paginator="true" class="p-datatable-gridlines mx-5" :rows="10" :rowHover="true"
          filterDisplay="menu" :loading="loading1" responsiveLayout="scroll" :columns="headers"
          :globalFilterFields="globalFilterFields" :filters="filters" selectionMode="single" dataKey="ID"
          :serialNumber="true">
        </Tableview>
      </div>
      <!-- {{ BreakUpitems }} -->
      <div class="itemsetailtable" v-if="ItemBreakUpTable">
        <b-container fluid>
          <b-row>
            <b-col lg="2" md="2" sm="4" cols="4">
              <div class="field">
                <CustomDropDown v-model="Filterdata.Brand" :items="FilterOpData.BrandOption"
                  :label="$t('StockAdjustment.Brand')" name="Brand" id="Brand" :required-icon="false"
                  :rules="{ required: false }" @update:modelValue="" />
              </div>
            </b-col>
            <b-col lg="2" md="2" sm="4" cols="4">
              <div class="field">
                <CustomDropDown v-model="Filterdata.ModelNumber" :items="FilterOpData.ModelNumberOption"
                  :label="$t('StockAdjustment.ModelNumber')" name="ModelNumber" id="ModelNumber" :required-icon="false"
                  :rules="{ required: false }" @update:modelValue="" />
              </div>
            </b-col>
            <b-col lg="2" md="2" sm="4" cols="4">
              <div class="field">
                <CustomDropDown v-model="Filterdata.Size" :items="FilterOpData.SizeOption"
                  :label="$t('StockAdjustment.Size')" name="Size" id="Size" :required-icon="false"
                  :rules="{ required: false }" @update:modelValue="" />
              </div>
            </b-col>
            <b-col lg="6" md="6" sm="12" cols="12">
              <Button class="printbtn btn btn-primary me-2 mt-4" @click="applyFilter()">
                Filter
              </Button>
              <Button class="printbtn btn btn-secondary mt-4" @click="clearFilter()">
                Clear
              </Button>
              <Button label="Barcode print" severity="success" icon="pi pi-print" class="printbtn ms-2"
                @click="printBarcodes()" />
            </b-col>
          </b-row>
        </b-container>
        <Tableview :value="BreakUpitems" :paginator="true" class="p-datatable-gridlines mx-5" :rows="10"
          :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll" :columns="Batchheaders"
          :globalFilterFields="globalFilterFields" :filters="filters" dataKey="BarCodeNo" :serialNumber="false"
          :selectionMode="true" @selection="SelectItem" :selection="selectedItems">
          <template v-slot:colour="{ data }">
            <span :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.BarCode }}
              <span v-if="data.IsBlock === 1">(Blocked)</span>
              <span v-else-if="data.IsFreeItem === 1">(promo)</span>
            </span>
          </template>
          <template v-slot:Rowcolour="{ data }">
            <span :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.RowNumber }}
            </span>
          </template>
          <template v-slot:Batchcolour="{ data }">
            <span v-if="data.Batchno != ''" :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.Batchno }}
            </span>
            <span v-else :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ "-" }}
            </span>
          </template>
          <template v-slot:Stockcolour="{ data }">
            <span :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.InWardStock }}
            </span>
          </template>

          <template v-slot:DCStockcolour="{ data }">
            <span :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.DCStock }}
            </span>
          </template>
          <template v-slot:PoItemStockcolour="{ data }">
            <span :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.PoItem }}
            </span>
          </template>
          <template v-slot:IssueReturnStockcolour="{ data }">
            <span :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.IssueReturnIn }}
            </span>
          </template>
          <template v-slot:IssueReturnOutcolour="{ data }">
            <span :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.IssueReturnOut }}
            </span>
          </template>
          <template v-slot:StockAdjustInStockcolour="{ data }">
            <span :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.StockAdjustIn }}
            </span>
          </template>
          <template v-slot:OutWardStockcolour="{ data }">
            <span :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.OutWardStock }}
            </span>
          </template>
          <template v-slot:GRNReturnStockcolour="{ data }">
            <span :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.GRNReturn }}
            </span>
          </template>
          <template v-slot:ConsumptionStockcolour="{ data }">
            <span :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.Consumption }}
            </span>
          </template>
          <template v-slot:IssueAgainstStockcolour="{ data }">
            <span :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.IssueAgainst }}
            </span>
          </template>
          <template v-slot:IssueNormalStockcolour="{ data }">
            <span :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.IssueNormal }}
            </span>
          </template>
          <template v-slot:StockAdjustOutStockcolour="{ data }">
            <span :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.StockAdjustOut }}
            </span>
          </template>
          <template v-slot:IssueAgainstIncolour="{ data }">
            <span :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.IssueAgainstIn }}
            </span>
          </template>
          <template v-slot:IssueNormalIncolour="{ data }">
            <span :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.IssueNormalIn }}
            </span>
          </template>
          <template v-slot:StockInHandcolour="{ data }">
            <span :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">

              {{
                Math.max(0, (data.StockInHand - (data.PickedQty + data.InTransist))).toFixed(2)
              }}
            </span>
          </template>
          <template v-slot:PickedQtycolour="{ data }">
            <span :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.PickedQty }}
            </span>
          </template>
          <template v-slot:InTransistcolour="{ data }">
            <span :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.InTransist }}
            </span>
          </template>
          <template v-slot:BlockReasoncolour="{ data }">
            <span v-if="data.BlockReason" :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.BlockReason }}
            </span>
            <span v-else :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ "-" }}
            </span>
          </template>
          <template v-slot:Expcolour="{ data }">
            <div v-if="data.ExpiryDate && data.ExpiryDate != '01 Jan 1900'" :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }" :style="getExpiryDateStyle(data.ExpiryDate)">
              {{ data.ExpiryDate }}
              <div class="expiry-message">{{ getExpiryMessage(data.ExpiryDate) }}</div>
            </div>
            <div v-else :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ "-" }}
            </div>
          </template>
          <template v-slot:Brandcolour="{ data }">
            <span :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.Brand }}
            </span>
          </template>
          <template v-slot:Modelcolour="{ data }">
            <span :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.ModelNumber }}
            </span>
          </template>
          <template v-slot:Sizecolour="{ data }">
            <span :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.Size }}
            </span>
          </template>
          <template v-slot:Manucolour="{ data }">
            <span v-if="data.GRNManufactureDate != '01 Jan 1900'" :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ data.GRNManufactureDate }}
            </span>
            <span v-else :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ "-" }}
            </span>
          </template>
          <template v-slot:action="{ data }">
            <div class="banbtndiv">
              <i class="pi pi-ban" @click="IsConfirm(data)"></i>
            </div>
          </template>
          <template v-slot:Brandmodelsize="{ data }">
            <p v-if="
              data.Brand == null &&
              data.ModelNumber == null &&
              data.Size == null
            ">
              {{ "-" }}
            </p>
            <p v-else>
              {{ data.Brand != null ? data.Brand : "-" }} /
              {{ data.ModelNumber != null ? data.ModelNumber : "-" }} /
              {{ data.Size != null ? data.Size : "-" }}
            </p>
          </template>
          <template v-slot:combinedBin="{ data }">
            <span v-if="
              data.RoomName != null ||
              data.RackName != null ||
              data.RowName != null ||
              data.BoxName != null
            " :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              <template v-if="data.RoomName">{{ data.RoomName }}</template>
              <template v-if="data.RoomName && data.RackName">/</template>
              <template v-if="data.RackName">{{ data.RackName }}</template>
              <template v-if="(data.RoomName || data.RackName) && data.RowName">/</template>
              <template v-if="data.RowName">{{ data.RowName }}</template>
              <template v-if="
                (data.RoomName || data.RackName || data.RowName) &&
                data.BoxName
              ">/</template>
              <template v-if="data.BoxName">{{ data.BoxName }}</template>
            </span>
            <span v-else :class="{
              'free-item': data.IsFreeItem === 1,
              'Block-item': data.IsBlock === 1,
            }">
              {{ "-" }}
            </span>
          </template>
        </Tableview>
      </div>

      <!-- <NormalTable :rowHover="true" filterDisplay="menu" responsiveLayout="scroll" :columns="Batchheaders" :data="BreakUpitems" :serialNumber=true>            
              </NormalTable> -->

      <!-- <div v-if="ItemBreakUpTable" class="breakup-table">
                <table class="table table-striped  ml3">
                    <thead>
                        <tr>
                            <th>Batch</th>
                            <th>Date of Mfts.</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in BreakUpitems" :key="index">
                            <td>{{ item['Batchno'] }}</td>
                            <td>{{ item['ExpiryDate'] }}</td>
                        </tr>
                    </tbody>
                </table>
            </div> -->
    </div>
    <Dialog v-model:visible="BlockPopup.Visible" modal :header="BlockPopup.PopUpHeaderName" :breakpoints="{
      '1980px': '55vw',
      '1440px': '60vw',
      '960px': '70vw',
      '640px': '90vw',
    }" class="overall-bg">
      <b-container fluid>
        <b-row>
          <b-col>
            <div class="field">
              <Textarea :name="BlockPopup.TextAareaName" :label="BlockPopup.TextAareaName" :rules="{ required: false }"
                :id="BlockPopup.TextAareaName" v-model="BlockPopup.BlockReason" />
              <Footer class="p-3" @cancel="BlockPopup.Visible = false" @save="SaveButton" />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </Dialog>
    <DeleteConfirmationVue :DeleteModel="Deletemodel" :content="contentdel" @yes="IsBlock(datablock)"
      @no="Deletemodel = false" />
    <Toast />
    <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues" :PrintType="PrintType"
      @closepopup="hidepopup" />
  </Sidebar>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  onMounted,
  watch,
  computed,
  nextTick,
} from "vue";

import { GChart } from "vue-google-charts";
//TableComponent
import service from "../../../../../modules/Inventory/Service/ItemMasService";
import { useRoute, useRouter } from "vue-router";

//Component
import NormalTable from "../../../../../components/FormComponents/NormalTable.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../components/FormComponents/Table.vue";
import Cancel from "../../../../../components/GeneralButtons/CancelButtton.vue";
import Save from "../../../../../components/GeneralButtons/SaveButton.vue";
import InputNumber from "../../../../../components/FormComponents/InputNumber.vue";
import Datepicker from "../../../../../components/FormComponents/DatePicker.vue";
import CustomDropDown from "../../../../../components/FormComponents/Dropdown.vue";
import TextInput from "../../../../../components/FormComponents/TextInput.vue";
import RackBoxMapping from "../../../../../modules/Inventory/components/Sidebar/RightSidebar/component/RackBoxMapping.vue";
import Pricing from "../../../../../modules/Inventory/components/Sidebar/RightSidebar/component/Pricing.vue";
import ItemDetails from "../../../../../modules/Inventory/components/Sidebar/RightSidebar/component/ItemDetails.vue";
import itemservice from "../../../../../modules/Inventory/Service/ItemMasService";
import Sidebar from "primevue/sidebar";
import ScrollTop from "primevue/scrolltop";
import moment from "moment";
import StockInService from "../../../../../modules/Inventory/Service/StockInService";
import Service from "../../../../../modules/Inventory/Service/StockOutService";
import StockReasonService from "../../../../../modules/Inventory/Service/StockReasonService";
import { useForm } from "vee-validate";
import DeleteConfirmationVue from "../../../../../components/FormComponents/DeleteConfirmation.vue";
import Footer from "../../../../../components/FormComponents/Footer.vue";
import Textarea from "../../../../../components/FormComponents/TextArea.vue";
import { useToast } from "primevue/usetoast";
import ItemStoreMappingService from "../../../../../modules/Inventory/Service/ItemStoreMappingService";
import RackService from "../../../../../modules/Inventory/Service/RackService";
import RowService from "../../../../../modules/Inventory/Service/RowService";
import AutoCompleteCustom from "../../../../../components/FormComponents/AutoComplete.vue";
import UnitMasterService from "../../../../../modules/Inventory/Service/UnitMasService";
import { useI18n } from "vue-i18n";
import { value } from 'dom7';
import CrystalReportPrintPopUp from "../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";

export default defineComponent({
  components: {
    GChart,
    RackBoxMapping,
    Pricing,
    ItemDetails,
    Cancel,
    TextInput,
    CustomDropDown,
    Datepicker,
    InputNumber,
    Save,
    Tableview,
    ScrollTop,
    DeleteConfirmationVue,
    Footer,
    Textarea,
    NormalTable,
    AutoCompleteCustom,
    CrystalReportPrintPopUp

  },
  props: {
    trigger: {
      type: Boolean,
      default: false,
    },
    itemId: {
      type: Number,
      default: ref(0),
    },
    StockInHand: {
      type: Number,
      default: ref(0),
    },
    ItemObj: {
      type: Object,
      default: {},
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    watch(props, (newValue) => {
      // itemid.value = props.itemId
      // sidebarwidth.value = "20rem";
      // showTable.value = false;
      // stockForm.value = true;
      // LoadItemDetails();
    });

    function showDetails() {
      showTable.value = true;
      sidebarwidth.value = "80rem";
      stockForm.value = false;
    }
    let items1 = ref([]);
    let BlockPopup = ref({
      Visible: false,
      BlockReason: "",
      PopUpHeaderName: "",
      TextAareaName: "",
      ConfirmPopupHeader: "",
      ConfirmPopupContent: "",
      Type: 0,
    });
    const route = useRoute();
    const headers = [
      {
        header: t("storetabdetails.itemdetailsrightsidebar.Category"),
        field: "ItemCategoryName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },

      {
        header: t("storetabdetails.itemdetailsrightsidebar.ItemCode"),
        field: "ItemCode",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: t("storetabdetails.itemdetailsrightsidebar.ItemName"),
        field: "ItemName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "AdjQty",
        field: "AdjQty",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: t("storetabdetails.itemdetailsrightsidebar.Difference"),
        field: "Difference",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: t("storetabdetails.itemdetailsrightsidebar.Reason"),
        field: "ReasonName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: t("storetabdetails.itemdetailsrightsidebar.UOM"),
        field: "UnitName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: t("storetabdetails.itemdetailsrightsidebar.UnitRate"),
        field: "UnitRate",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: t("storetabdetails.itemdetailsrightsidebar.TotalValue"),
        field: "TotalValue",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
    ];
    const Batchheaders = [
      {
        header: "#",
        field: "RowNumber",
        slot: "Rowcolour",
        bodyclass: "boldclass",
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.itemdetailsrightsidebar.Barcode"),
        field: "BarCodeNo",
        slot: "colour",
        class: "smallwidth coumnfreezeleft1",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.itemdetailsrightsidebar.Batch"),
        field: "Batchno",
        slot: "Batchcolour",
        class: "smallwidth coumnfreezeleft2",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.itemdetailsrightsidebar.InwardStock"),
        field: "InWardStock",
        slot: "Stockcolour",
        class: "smallwidth",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
      {
        header: "Issue With Indent",
        field: "IssueAgainstIn",
        slot: "IssueAgainstIncolour",
        class: "smallwidth",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
      {
        header: "Issue Without Indent",
        field: "IssueNormalIn",
        slot: "IssueNormalIncolour",
        class: "smallwidth",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
      {
        header: "GRNStock",
        field: "PoItem",
        slot: "PoItemStockcolour",
        class: "smallwidth",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
      {
        header: "DCStock",
        field: "DCStock",
        slot: "DCStockcolour",
        class: "smallwidth",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
      {
        header: "IssueReturn",
        field: "IssueReturnIn",
        slot: "IssueReturnStockcolour",
        class: "smallwidth",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
      {
        header: "StockAdjust",
        field: "StockAdjustIn",
        slot: "StockAdjustInStockcolour",
        class: "smallwidth",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.itemdetailsrightsidebar.OutwardStock"),
        field: "OutWardStock",
        slot: "OutWardStockcolour",
        class: "smallwidth",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
      {
        header: "GRNReturn",
        field: "GRNReturn",
        slot: "GRNReturnStockcolour",
        class: "smallwidth",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
      {
        header: "Consumption",
        field: "Consumption",
        slot: "ConsumptionStockcolour",
        class: "smallwidth",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
      {
        header: "Issue With Indent",
        field: "IssueAgainst",
        slot: "IssueAgainstStockcolour",
        class: "smallwidth",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
      {
        header: "IssueIssue Without IndentNormal",
        field: "IssueNormal",
        slot: "IssueNormalStockcolour",
        class: "smallwidth",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
      {
        header: "IssueReturn",
        field: "IssueReturnOut",
        slot: "IssueReturnOutcolour",
        class: "smallwidth",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
      {
        header: "StockAdjust",
        field: "StockAdjustOut",
        slot: "StockAdjustOutStockcolour",
        class: "smallwidth",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
      // {
      //     header: "Issue Return Qty",
      //     field: "IssueReturn",
      //     bodyclass: "boldclass",
      //     // fieldDisplay: "false"
      // },
      // {
      //     header: "GRN Return Qty",
      //     field: "PurchaseReturn",
      //     bodyclass: "boldclass",
      //     // fieldDisplay: "false"
      // },
      //
      {
        header: t("storetabdetails.itemdetailsrightsidebar.AvlQty"),
        field: "StockInHand",
        slot: "StockInHandcolour",
        class: "smallwidth",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
      {
        header: "PickedQty",
        field: "PickedQty",
        slot: "PickedQtycolour",
        class: "smallwidth",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
      {
        header: "InTransist",
        field: "InTransist",
        slot: "InTransistcolour",
        class: "smallwidth",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.itemdetailsrightsidebar.BrandModelSize"),
        field: "",
        slot: "Brandmodelsize",
        fieldDisplay: "false",
        bodyclass: "right_td",
      },
      {
        header: t("storetabdetails.itemdetailsrightsidebar.DateofExp"),
        field: "ExpiryDate",
        slot: "Expcolour",
        class: "smallwidth",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.itemdetailsrightsidebar.DateofMfg"),
        field: "GRNManufactureDate",
        slot: "Manucolour",
        class: "smallwidth",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.itemdetailsrightsidebar.BinLocation"),
        field: "BinLocation",
        class: "smallwidth",
        bodyclass: "right_td",
        fieldDisplay: "false",
        slot: "combinedBin",
      },
      {
        header: t("storetabdetails.itemdetailsrightsidebar.BlockReason"),
        field: "BlockReason",
        slot: "BlockReasoncolour",
        class: "smallwidth",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
      {
        field: "",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "last-column-position",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
    ];

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Code: { value: null, matchMode: FilterMatchMode.IN, options: items1 },
      TemplateInfo: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items1,
      },
    };

    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });
    const globalFilterFields = ref(headers.map((col) => col.field));

    const ItemBreakUpTable = ref(false);
    let loading1 = ref(false);
    let itemid = ref(0);
    let slidervalue: any = ref(50);
    const active = ref(true);
    const location = ref("");
    const reason = ref("");
    const date = ref("");
    const Qty = ref("");
    const AvailQty = ref("");
    const showTable = ref(false);
    const stockForm = ref(true);
    const sidebarwidth = ref("27rem");
    const sidebarMinwidth = ref("27rem");

    const Deletemodel = ref(false);
    const contentdel = ref("");
    let ItemDetails = ref({});
    const datas = ref();
    const datablock = ref();
    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let Admin = Number(session.Admin);
    const placement = ref("right");
    const toast = useToast();
    const { handleSubmit, errors, resetForm, resetField } = useForm();
    const ItemData: any = ref({
      Id: ref(),
      ItemName: "",
      ProductId: "",
      SalesPrice: 0.0,
      PurchasePrice: 0.0,
      MarkupPercentage: 0.0,
      MRP: 0.0,
      PurchasePercentage: 0.0,
      ReOrderLevel: 0,
      ItemCategoryName: "",
      StockInHand: 0,
      AvgDailyConsumption: 0.0,
      ExpStock: 0,
      RequestCount: 0,
      POCount: 0,
      Batchno: "",
      ExpiryDate: "",
      ItemCount: 0,
      PoId: "",
      POItemCount: 0,
      Margins: 0,
      AvlCount: 0,
      RowNumber: 0,
      Brand: "",
      ModelNumber: "",
      Size: "",
      GRNManufactureDate: "",
      PickedQty: 0,
      InTransist: 0,
    });
    let StoreId = "";
    let StoreBranchMapId = 0;
    const loading = ref(false);
    const BreakUpitems = ref([]);

    const Chartdata = ref([["Element", 0, { role: "style" }]]);
    const items: any = ref([
      // { dateTime: '2023-05-20 10:00', reason: 'Stock adjustment', adjustQty: 10 },
      // { dateTime: '2023-05-21 12:00', reason: 'Return', adjustQty: -5 },
      // { dateTime: '2023-05-22 14:00', reason: 'New stock', adjustQty: 20 }
      // Add more items as needed
    ]);

    const Batchitems = ref([]);

    const ViewDetails = () => {
      debugger;
      //window.scrollTop(0,0);

      sidebarwidth.value = "96%";
      showTable.value = true;
      ItemBreakUpTable.value = false;
      stockForm.value = false;
    };
    const BreakUpDetails = () => {
      sidebarwidth.value = "96%";
      ItemBreakUpTable.value = true;
      stockForm.value = false;
      showTable.value = false;
    };
    const options = {
      width: 285,
      height: 200,
    };

    function stockAdjust() {
      sidebarwidth.value = "60%";
      showTable.value = false;
      stockForm.value = true;
      ItemBreakUpTable.value = false;
      LoadItemConfigurationt();
      getroombystoreid();
    }
    let StoreBranchId: any;
    onMounted(() => {
      sidebarwidth.value = "27rem";
      StoreId = String(route.query.Id);
      StoreBranchId = String(route.query.BranchId);

      StoreBranchMapId = Number(route.query.storebranchmapid);
      itemid.value = props.itemId;

      showTable.value = false;
      stockForm.value = false;
      LoadItemDetails();
      LoadStockAdjustment();
      LoadReason();
      UOM()
      // StockAdjData.value.StockInHand = String(ItemData.StockInHand);
      Object.assign(ItemDetails.value, props.ItemObj);
    });
    let itemsBatchNoList: any = ref();
    let DuplicateitemsBatchNoList: any = ref();
    let itemsBarCodeNoList: any = ref();

    async function LoadItemDetails() {
      try {
        debugger;
        loading.value = true;
        const data_response = await itemservice.GetItemDetails(
          itemid.value,
          StoreId,
          StoreBranchId,
          HospitalId
        );

        let result = data_response["result"].ItemDetails.map((item) => {
          const min = item.SalesPrice - item.PurchasePrice;
          const max = item.SalesPrice + item.PurchasePrice;
          const margin = (min * 100) / max;
          ItemData.value.Margins = margin.toFixed(2);

          const avl = item.AvlqtyCount;
          const stockin = item.StockInHand;
          const AvlCount = (Number(stockin) / Number(avl)) * 100;
          ItemData.value.AvlCount = AvlCount;

          return item;
        });
        let count = 0;

        let result1 = data_response["result"].BatchList.map((item) => {
          count++;
          debugger;
          item.ExpiryDate = moment(item.ExpiryDate, "DD-MM-YYYY").format(
            "DD MMM YYYY"
          );
          item.RowNumber = count;
          item.GRNManufactureDate = moment(item.GRNManufactureDate).format(
            "DD MMM YYYY"
          );
          if (item.GRNManufactureDate === "Invalid date") {
            item.GRNManufactureDate = "";
          }

          return item;
        });
        let result2 = data_response["result"].UsersList.slice(0, 5);

        let BatchTopList = result1.slice(0, 5);
        Object.keys(ItemData.value).forEach((key) => {
          if (result[0][key]) ItemData.value[key] = result[0][key];
        });
        //StockAdjData.value.StockInHand = String(ItemData.value.StockInHand);
        Batchitems.value = BatchTopList;
        itemsBatchNoList.value = result1
          .filter((item) => item.Batchno != null || "")
          .map((item) => {
            item.label = item.Batchno + " (" + item.BarCode + " )";
            item.value = item.Batchno;
            return item;
          });
        DuplicateitemsBatchNoList.value = JSON.parse(
          JSON.stringify(itemsBatchNoList.value)
        );
        itemsBarCodeNoList.value = result1.map((item) => {
          item.name = item.BarCode;
          item.value = item.BarCodeNo;
          return item;
        });
        // itemsBatchNoList.value = Array.from(
        //     new Set(itemsBatchNoList.value.map(item => item.value))
        // ).map(batchno => ({
        //     name: batchno,
        //     value: batchno
        // }));
        console.log(BatchTopList);
        BreakUpitems.value = result1;
        const data = [
          ["Element", "Density", { role: "style" }],
          ...result2.map((item) =>
            item.PatientId != 0
              ? [String(item.PatientId), item.Qty, "#dab8a7"]
              : [String(item.UserId), item.Qty, "#dab8a7"]
          ),
        ];
        const data1 = [
          ["Element", "Density", { role: "style" }],
          ["", 0, "#dab8a7"],
        ];

        if (data.length > 1) {
          Chartdata.value = data;
        } else {
          Chartdata.value = data1;
        }
        await LoadItemConfigurationfilter();
      } catch (error) {
        console.log(error);
      }
    }
    /*--Stock Adjustment*/
    let StockAdjData = ref({
      DocDate: "",
      RoomId: ref(),
      RackId: ref(),
      RowId: ref(),
      BoxId: ref(),
      Quantity: 0,
      StockReasonId: ref(),
      StockInHand: "0",
      ExpiryDate: "",
      Batch: "",
      Brand: ref(),
      Size: ref(),
      ModelNumber: ref(),
      BarCodeNo: "0",
      BarCode: "",
      ManufactureDate: "",
      UOM: 0,
      UnitRate: 0,
      ConversionFactor: 1,
      OrderUnitId: 0,
      UnitId: 0,
      BatchNo: ""
    });

    let Filterdata = ref({
      Brand: ref(),
      Size: ref(),
      ModelNumber: ref(),
    });


    let StockAdjOpData = ref({
      RoomOption: [],
      RowOption: [],
      RackOption: [],
      BoxOption: [],
      ReasonOption: [],
      BrandOption: [],
      ModelNumberOption: [],
      SizeOption: [],
      UOMoption: [],
      DuplicateUOMoption: []

    });
    let FilterOpData: any = ref({
      BrandOption: [],
      ModelNumberOption: [],
      SizeOption: [],
    });

    let FieldDisable = ref({
      Brand: ref(false),
      ModelNumber: ref(false),
      Size: ref(false),
      Room: ref(false),
      Row: ref(false),
      Rack: ref(false),
      Box: ref(false),
      ExpiryDate: ref(false),
      UOM: ref(true)
    });
    let TotOption = ref([]);
    //Load Room
    let CurrentUOM: any = "";
    async function Loadloaction(event) {
      try {
        debugger;
        let data_response: any;
        if (ItemDetails.value?.["BatchRequired"]) {
          data_response = await itemservice.GetLocationDetails(
            HospitalId,
            BranchId,
            itemid.value,
            StoreId,
            event.value.BarCodeNo
          );
        } else {
          await filterBatchNo(StockAdjData.value.Batch)
          data_response = await itemservice.GetLocationDetails(
            HospitalId,
            BranchId,
            itemid.value,
            StoreId,
            event
          );
        }
        if (data_response["result"].length > 0) {
          TotOption.value = JSON.parse(JSON.stringify(data_response["result"]));
          const transformedData = data_response["result"]
            .filter((item) => item.RoomId != 0)
            .map((item) => {
              item.name = item.RoomName;
              item.value = item.RoomId;
              return item;
            });
          StockAdjData.value.RoomId = data_response["result"][0]["RoomId"];
          StockAdjData.value.RackId = data_response["result"][0]["RackId"];
          StockAdjData.value.RowId = data_response["result"][0]["RowId"];
          StockAdjData.value.BoxId = data_response["result"][0]["BoxId"];
          StockAdjData.value.StockInHand = data_response["result"][0]["StockInHand"];
          StockAdjData.value.Brand = data_response["result"][0]["Brand"];
          StockAdjData.value.ModelNumber = data_response["result"][0]["ModelNumber"];
          StockAdjData.value.Size = data_response["result"][0]["Size"];
          StockAdjData.value.UOM = data_response["result"][0]["UOM"];
          StockAdjData.value.UnitRate = data_response["result"][0]["UnitRate"];
          StockAdjData.value.BarCode = data_response["result"][0]["BarCode"];
          StockAdjData.value.BarCodeNo = data_response["result"][0]["BarCodeNo"];
          StockAdjData.value.ExpiryDate = moment(data_response["result"][0]["ExpiryDate"]).format("YYYY-MM-DD");
          StockAdjData.value.ManufactureDate = data_response["result"][0]["ManufactureDate"];
          StockAdjData.value.ConversionFactor = data_response["result"][0]["ConversionFactor"];
          StockAdjData.value.OrderUnitId = data_response["result"][0]["OrderUnitId"];
          StockAdjData.value.UnitId = data_response["result"][0]["UnitId"];
          StockAdjData.value.BatchNo = data_response["result"][0]["BatchNo"];
          if (transformedData.length != 0) {
            StockAdjOpData.value.RoomOption = transformedData;
          }
          if (data_response["result"][0]["UnitId"] == data_response["result"][0]["UOM"]) {
            CurrentUOM = "SalesUnit";
          } else if (data_response["result"][0]["OrderUnitId"] == data_response["result"][0]["UOM"]) {
            CurrentUOM = "PurchaseUnit";
          }
          StockAdjOpData.value.UOMoption = StockAdjOpData.value.DuplicateUOMoption.filter(
            (items: any) =>
              items.Id == data_response["result"][0]["UnitId"] || items.Id == data_response["result"][0]["OrderUnitId"]
          );
          StockAdjData.value.UOM = data_response["result"][0]["UOM"];
          FieldDisable.value.UOM = false
          FieldDisable.value.Brand = true;
          FieldDisable.value.ModelNumber = true;
          FieldDisable.value.Size = true;
          FieldDisable.value.Room = true;
          FieldDisable.value.Rack = true;
          FieldDisable.value.Row = true;
          FieldDisable.value.Box = true;
          FieldDisable.value.ExpiryDate = true;
        }
      } catch (error) {
        console.log(error);
      }
    }

    ///
    const filterBatchNo = (data) => {
      debugger;
      if (ItemDetails.value?.["BatchRequired"]) {
        itemsBatchNoList.value = DuplicateitemsBatchNoList.value.filter(
          (item) => item.Batchno.toLowerCase().includes(data.toLowerCase())
        );
      }
      FieldDisable.value.Brand = false;
      FieldDisable.value.ModelNumber = false;
      FieldDisable.value.Size = false;
      FieldDisable.value.Room = false;
      FieldDisable.value.Rack = false;
      FieldDisable.value.Row = false;
      FieldDisable.value.Box = false;
      FieldDisable.value.ExpiryDate = false;
      StockAdjData.value.Brand = ref();
      StockAdjData.value.ModelNumber = ref();
      StockAdjData.value.RoomId = ref();
      StockAdjData.value.RackId = ref();
      StockAdjData.value.RowId = ref();
      StockAdjData.value.BoxId = ref();
      StockAdjData.value.Size = ref();
      StockAdjData.value.StockInHand = "0";
      StockAdjData.value.ExpiryDate = "";
      debugger;
    };
    async function getroombystoreid() {
      try {
        const dataresponse = await ItemStoreMappingService.getroommaster(
          StoreId
        );
        StockAdjOpData.value.RoomOption = dataresponse["result"].map(
          (item: any) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          }
        );
      } catch (error) {
        console.log(error);
      }
    }

    // get rack name by room id

    async function getrackbyroomid() {
      try {
        if (StockAdjData.value.RoomId != null) {
          const dataresponse = await RackService.getRackByRoomId(
            StockAdjData.value.RoomId
          );

          StockAdjOpData.value.RackOption = dataresponse["result"].map(
            (item: any) => {
              item.name = item.Name;
              item.value = item.Id;
              return item;
            }
          );
        } else {
          StockAdjOpData.value.RackOption = [];
          StockAdjOpData.value.RowOption = [];
          StockAdjOpData.value.BoxOption = [];
          StockAdjData.value.RackId = ref();
          StockAdjData.value.RowId = ref();
          StockAdjData.value.BoxId = ref();
        }

        //   alert(JSON.stringify(StockAdjOpData.value.RackOption))
      } catch (error) {
        console.log(error);
      }
    }

    // get row name by rack name

    async function getrowbyrackid() {
      try {
        if (StockAdjData.value.RackId != null) {
          const dataresponse = await RowService.getRowByRackId(
            StockAdjData.value.RackId
          );

          StockAdjOpData.value.RowOption = dataresponse["result"].map(
            (item: any) => {
              item.name = item.Name;
              item.value = item.Id;
              return item;
            }
          );
        } else {
          StockAdjOpData.value.RowOption = [];
          StockAdjOpData.value.BoxOption = [];

          StockAdjData.value.RowId = ref();
          StockAdjData.value.BoxId = ref();
        }
      } catch (error) {
        console.log(error);
      }
    }

    // get box name by rowid

    async function getboxbyrowid() {
      try {
        // alert('s')
        if (StockAdjData.value.RowId != null) {
          const dataresponse = await ItemStoreMappingService.getboxmaster(
            StockAdjData.value.RowId
          );

          StockAdjOpData.value.BoxOption = dataresponse["result"].map(
            (item: any) => {
              item.name = item.BoxName;
              item.value = item.Id;
              return item;
            }
          );
        } else {
          StockAdjOpData.value.BoxOption = [];
          StockAdjData.value.BoxId = ref();
        }
      } catch (error) {
        console.log(error);
      }
    }

    ///
    //RoomOnchange
    function RoomOnChange() {
      debugger;

      let arr: any = JSON.parse(JSON.stringify(TotOption.value));
      const transformedData = arr
        .filter(
          (i1: any) => i1.RoomId == StockAdjData.value.RoomId && i1.RackId != 0
        )
        .map((item: any) => {
          item.name = item.RackName;
          item.value = item.RackId;
          return item;
        });
      const uniqueRack: any = Array.from(
        new Map(transformedData.map((item) => [item.value, item])).values()
      );

      // Assign the unique values to the RoomOption
      StockAdjOpData.value.RackOption = uniqueRack;

      CalStock();
    }
    //RackOnchange
    function RackOnChange() {
      let arr1: any = JSON.parse(JSON.stringify(TotOption.value));
      const transformedData = arr1
        .filter(
          (i1: any) => i1.RackId == StockAdjData.value.RackId && i1.RowId != 0
        )
        .map((item: any) => {
          item.name = item.RowName;
          item.value = item.RowId;
          return item;
        });
      const uniqueRow: any = Array.from(
        new Map(transformedData.map((item) => [item.value, item])).values()
      );

      // Assign the unique values to the RoomOption
      StockAdjOpData.value.RowOption = uniqueRow;
      CalStock();
    }
    //RowOnchange
    function RowOnChange() {
      let arr2: any = JSON.parse(JSON.stringify(TotOption.value));
      const transformedData = arr2
        .filter(
          (i1: any) => i1.RowId == StockAdjData.value.RowId && i1.BoxId != 0
        )
        .map((item: any) => {
          item.name = item.BoxName;
          item.value = item.BoxId;
          return item;
        });
      const uniqueBox: any = Array.from(
        new Map(transformedData.map((item) => [item.value, item])).values()
      );

      // Assign the unique values to the RoomOption
      StockAdjOpData.value.BoxOption = uniqueBox;
      // StockAdjOpData.value.BoxOption = (arr2.length > 0) ? arr2 : [];
      CalStock();
    }
    //BoxOnChange
    function BoxOnChange() {
      CalStock();
    }
    //Stock In Hand Cal
    function CalStock() {
      debugger;
      let arr = JSON.parse(JSON.stringify(TotOption.value));
      arr = arr.filter((i1: any) => {
        // Always check if BoxId matches
        const isBoxIdMatch = StockAdjData.value.BoxId
          ? i1.BoxId == StockAdjData.value.BoxId
          : true;

        // Check if RackId should be considered
        const isRackIdMatch = StockAdjData.value.RackId
          ? i1.RackId == StockAdjData.value.RackId
          : true;
        const isRowIdMatch = StockAdjData.value.RowId
          ? i1.RowId == StockAdjData.value.RowId
          : true;
        const isRoomIdMatch = StockAdjData.value.RoomId
          ? i1.RoomId == StockAdjData.value.RoomId
          : true;

        // Return true only if both conditions are satisfied
        return isBoxIdMatch && isRackIdMatch && isRowIdMatch && isRoomIdMatch;
      });
      let AvlQty = props.StockInHand;
      if (arr.length > 0) {
        AvlQty = arr.reduce((acc, cur) => acc + Number(cur.StockInHand), 0);
      }
      StockAdjData.value.StockInHand = String(AvlQty);
    }
    //Submit Stock Adjustment
    const SubmitStocAdjustment = handleSubmit(async (values) => {
      debugger;
      if (!StockAdjData.value.Quantity) {
        toast.add({
          severity: "warn",
          summary: "Enter the Quantity",
          detail: "",
          life: 3000,
        });
        return false;
      }
      if (
        StockAdjData.value.Quantity < 0 &&
        Math.abs(StockAdjData.value.Quantity) >
        Number(StockAdjData.value.StockInHand)
      ) {
        toast.add({
          severity: "warn",
          summary: "Quantity Should Be Less Then AvailableQuantity",
          detail: "",
          life: 3000,
        });
        return false;
      }

      let currentDate = new Date().toISOString().slice(0, 10);
      let result: any;
      let msg: String = "";
      let id: any = 0;
      const requestForm = {
        DocType: "20",
        DocNo: "",
        DocDate: currentDate,
        StoreId: StoreId,
        StoreBrMapId: StoreBranchMapId,
        TotalQty: 0,
        SupplierId: 0,
        Remarks: "",
        Id: 0,
        InvoiceNo: "",
        InvoiceDate: currentDate,
        InwardDate: currentDate,
        DcDate: currentDate,
        CreatedAt: currentDate,
        CreatedBy: 0,
        ModifiedAt: currentDate,
        ModifiedBy: 0,
        HospitalId: HospitalId,
        BranchId: StoreBranchId,
        EntityId: 332,
        EntityOperationId: 0,
        IsApproved: 1,
        PickStartTime: currentDate,
        PickEndTime: currentDate,
      };
      let arrs: any = [];
      let obj = {};
      let qty: Number = Math.abs(Number(StockAdjData.value.Quantity));
      (obj["StoreId"] = StoreId),
        (obj["ItemId"] = itemid.value),
        (obj["Qty"] = qty),
        (obj["PoQty"] = qty),
        (obj["ActualQty"] = qty),
        (obj["HSNId"] = ItemDetails.value["HSNId"]),
        (obj["UnitMRP"] = ItemDetails.value["MRP"]),
        (obj["UnitRate"] = StockAdjData.value["UnitRate"]);
      obj["UOM"] = StockAdjData.value["UOM"];
      (obj["Rate"] = StockAdjData.value["UnitRate"] * Number(qty)),
        (obj["PurchaseTax"] = ItemDetails.value["PurchasePercentage"]),
        (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
        (obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
        (obj["CreatedBy"] = UserId),
        (obj["ModifiedBy"] = UserId),
        (obj["RoomId"] = StockAdjData.value["RoomId"]
          ? StockAdjData.value["RoomId"]
          : 0);
      obj["RackId"] = StockAdjData.value["RackId"]
        ? StockAdjData.value["RackId"]
        : 0;
      obj["RowId"] = StockAdjData.value["RowId"]
        ? StockAdjData.value["RowId"]
        : 0;
      obj["BoxId"] = StockAdjData.value["BoxId"]
        ? StockAdjData.value["BoxId"]
        : 0;
      obj["Brand"] = StockAdjData.value["Brand"]
        ? StockAdjData.value["Brand"]
        : 0;
      obj["ModelNumber"] = StockAdjData.value["ModelNumber"]
        ? StockAdjData.value["ModelNumber"]
        : 0;
      obj["Size"] = StockAdjData.value["Size"] ? StockAdjData.value["Size"] : 0;
      obj["StockReasonId"] = StockAdjData.value["StockReasonId"]
        ? StockAdjData.value["StockReasonId"]
        : 0;
      obj["RefBarCode"] = StockAdjData.value["BarCode"]
        ? StockAdjData.value["BarCode"]
        : "";
      obj["RefBarCodeNo"] = Number(
        StockAdjData.value["BarCodeNo"] ? StockAdjData.value["BarCodeNo"] : 0
      );
      obj["StockReasonId"] = StockAdjData.value["StockReasonId"]
        ? StockAdjData.value["StockReasonId"]
        : 0;
      if (
        StockAdjData.value["ExpiryDate"] != "01-01-0001" &&
        StockAdjData.value["ExpiryDate"] != ""
      ) {
        obj["ExpiryDate"] = StockAdjData.value["ExpiryDate"];
      } else {
        obj["ExpiryDate"] = "1900-01-01T19:17:58.632+05:30";
      }
      if (
        StockAdjData.value["ManufactureDate"] != "01-01-0001" &&
        StockAdjData.value["ManufactureDate"] != ""
      ) {
        obj["ManufactureDate"] = StockAdjData.value["ManufactureDate"];
      } else {
        obj["ManufactureDate"] = "1900-01-01T19:17:58.632+05:30";
      }
      obj["BatchNo"] = StockAdjData.value["BatchNo"] || "";
      (obj["PickStartTime"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
        (obj["PickEndTime"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
        arrs.push(obj);
      if (StockAdjData.value.Quantity > 0) {
        result = await StockInService.createStockInTM(requestForm);
        msg = result["ErrorInfo"].ErrorCode;

        if (msg == null) {
          arrs.map((item) => {
            item.RefId = result["result"];
            return item;
          });
          result = await StockInService.createStockInDetails(arrs);
          msg = result["ErrorInfo"].ErrorCode;
          let BarCoderesult =
            await StockInService.CreateBarCodeMappingStockAdjust(
              arrs[0].RefId,
              arrs[0].RoomId,
              arrs[0].RackId,
              arrs[0].RowId,
              arrs[0].BoxId
            );
          let BarCodemsg = BarCoderesult["ErrorInfo"].ErrorCode;
        }
      } else {
        // alert("stockout");
        result = await Service.creatStockOutMasterTM(requestForm);
        msg = result["ErrorInfo"].ErrorCode;

        if (msg == null) {
          arrs.map((item) => {
            item.RefId = result["result"];
            item.BarCode = StockAdjData.value["BarCode"]
              ? StockAdjData.value["BarCode"]
              : "";
            item.BarCodeNo = Number(
              StockAdjData.value["BarCodeNo"]
                ? StockAdjData.value["BarCodeNo"]
                : 0
            );

            return item;
          });
          result = await Service.CreateBarcodeStockOut(arrs);
          msg = result["ErrorInfo"].ErrorCode;
        }
      }
      if (msg == null) {
        toast.add({
          severity: "success",
          summary: "Stock Adjusted successfully",
          detail: "",
          life: 3000,
        });
        ViewDetails();
        LoadStockAdjustment();
        LoadItemDetails();
        resetForm();
      }
    });
    //Load Stock Adjustment Table
    async function LoadItemConfigurationt() {
      try {
        const data_response = await itemservice.GetItemConfigurationByItemId(
          HospitalId,
          BranchId,
          itemid.value
        );
        StockAdjOpData.value.BrandOption = data_response["result"]
          .filter((items) => items.Type == 1)
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
        StockAdjOpData.value.ModelNumberOption = data_response["result"]
          .filter((items) => items.Type == 2)
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
        StockAdjOpData.value.SizeOption = data_response["result"]
          .filter((items) => items.Type == 3)
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        console.log(error);
      }
    }

    async function LoadItemConfigurationfilter() {
      FilterOpData.value.BrandOption = [
        ...new Set(
          BreakUpitems.value
            .map((item: any) => item.Brand)
            .filter((brand): brand is string => !!brand)
        ),
      ].map((brand) => ({
        name: brand,
        value: brand,
      }));

      FilterOpData.value.ModelNumberOption = [
        ...new Set(
          BreakUpitems.value
            .map((item: any) => item.ModelNumber)
            .filter((ModelNumber): ModelNumber is string => !!ModelNumber)
        ),
      ].map((ModelNumber) => ({
        name: ModelNumber,
        value: ModelNumber,
      }));

      FilterOpData.value.SizeOption = [
        ...new Set(
          BreakUpitems.value
            .map((item: any) => item.Size)
            .filter((Size): Size is string => !!Size)
        ),
      ].map((Size) => ({
        name: Size,
        value: Size,
      }));

      // FilterOpData.value.SizeOption = BreakUpitems.value.map((i: any) => {
      //   i.name = i.Size;
      //   i.value = i.Size;

      //   return i;
      // });
    }

    // Function to apply the filter

    async function applyFilter() {
      debugger;
      await LoadItemDetails();
      // BreakUpitems.value = BreakUpitems.value.filter((item: any) => {
      //   return (
      //     (Filterdata.value.Brand && item.Brand === Filterdata.value.Brand) ||
      //     (Filterdata.value.ModelNumber &&
      //       item.ModelNumber === Filterdata.value.ModelNumber) ||
      //     (Filterdata.value.Size && item.Size === Filterdata.value.Size)
      //   );
      // });
      BreakUpitems.value = BreakUpitems.value.filter((item: any) => {
        const matchBrand = Filterdata.value.Brand
          ? item.Brand === Filterdata.value.Brand
          : true;
        const matchModel = Filterdata.value.ModelNumber
          ? item.ModelNumber === Filterdata.value.ModelNumber
          : true;
        const matchSize = Filterdata.value.Size
          ? item.Size === Filterdata.value.Size
          : true;

        return matchBrand && matchModel && matchSize;
      });
    }

    // // Function to clear the filters
    async function clearFilter() {
      Filterdata.value.Brand = null;
      Filterdata.value.ModelNumber = null;
      Filterdata.value.Size = null;
      LoadItemDetails();
    }
    async function UOM() {
      debugger;
      try {
        const dataresponse = await UnitMasterService.getdata();

        console.log(dataresponse);
        debugger;

        StockAdjOpData.value.UOMoption = dataresponse["result"]
          .filter((x) => x.HospitalId == HospitalId)
          .map((item: any) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
        StockAdjOpData.value.DuplicateUOMoption = JSON.parse(
          JSON.stringify(StockAdjOpData.value.UOMoption)
        );
      } catch (error) {
        console.log(error);
      }
    }
    async function LoadStockAdjustment() {
      try {
        const data_response = await itemservice.GetStockAdjustDetails(
          itemid.value,
          StoreId
        );
        let mapdata = data_response["result"].map((item) => {
          item.AdjQty =
            item.StockAdjType == 1
              ? "-" + item.AdjustQty
              : "+" + item.AdjustQty;
          item.color = item.StockAdjType == 1 ? "red" : "green";

          return item;
        });
        items1.value = mapdata;
        items.value = mapdata.slice(0, 5);
      } catch (error) {
        console.log(error);
      }
    }
    //Load Reason
    async function LoadReason() {
      try {
        const response = await StockReasonService.getlistdata();
        if (Admin == 1) {
          response["result"] = response["result"]
            .filter((items) => items.HospitalId == HospitalId)
            .map((item) => {
              item.name = item.ReasonName;
              item.value = item.Id;

              return item;
            });
        } else {
          response["result"] = response["result"]
            .filter(
              (items) =>
                items.HospitalId == HospitalId &&
                items.BranchId == StoreBranchId
            )
            .map((item) => {
              item.name = item.ReasonName;
              item.value = item.Id;

              return item;
            });
        }
        StockAdjOpData.value.ReasonOption = response["result"];
      } catch (error) { }
    }
    let DispExp = ref(true);
    function QtyChange() {
      debugger;
      StockAdjData.value.Quantity < 0
        ? (DispExp.value = false)
        : (DispExp.value = true);
      if (
        StockAdjData.value.Quantity < 0 &&
        Math.abs(StockAdjData.value.Quantity) >
        Number(StockAdjData.value.StockInHand)
      ) {
        toast.add({
          severity: "warn",
          summary: "Quantity Should Be Less Then AvailableQuantity",
          detail: "",
          life: 3000,
        });
      }
    }

    function IsConfirm(data) {
      debugger;
      datablock.value = data;
      BlockPopup.value.BlockReason = "";
      // Deletemodel.value = true
      if (data.IsBlock == 1) {
        Deletemodel.value = true;
        contentdel.value = t("confirmation.UnBlockThisBarcode");
      } else {
        BlockPopup.value.Visible = true;
        BlockPopup.value.TextAareaName = t("confirmation.EnterReason");
        BlockPopup.value.PopUpHeaderName = t("confirmation.BlockThisBarcode");
        contentdel.value = t("confirmation.BlockThisBarcode");
      }
    }

    async function IsBlock(data) {
      loading.value = true;
      debugger;
      try {
        Object.keys(data).forEach((key) => {
          if (data[key] === null) {
            data[key] = "";
          }
        });

        data.DocDate = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        data.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        data.BlockReason = BlockPopup.value.BlockReason;
        let result: any = "";
        result = await itemservice.updatebarcodeblock(
          data.BarCodeNo,
          data.BlockReason
        );
        let message = result["ErrorInfo"].ErrorCode;
        if (result["result"] != "False" && message == null) {
          Deletemodel.value = false;
          loading.value = false;
          LoadItemDetails();
        } else if (message == null) {
          Deletemodel.value = false;
          loading.value = false;
          LoadItemDetails();
        }
      } catch (error) {
        loading.value = false;
      }
    }

    const ItemBreakUPHeaders = [
      {
        header: t("storetabdetails.itemdetailsrightsidebar.Barcode"),
        field: "BarCodeNo",
        slot: "colour",
        class: "smallwidth",
        bodyclass: "right_td",
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.itemdetailsrightsidebar.Batch"),
        field: "Batchno",
        slot: "Batchnoslot",
        bodyclass: "boldclass",
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.itemdetailsrightsidebar.DateofExp"),
        field: "ExpiryDate",
        bodyclass: "boldclass",
        slot: "ExpiryDateslot",
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.itemdetailsrightsidebar.AvlQty"),
        field: "StockInHand",
        bodyclass: "boldclass",
        slot: "StockInHandslot",
        fieldDisplay: "false",
      },
      //   {
      //     header: "PickedQty",
      //     field: "PickedQty",
      //     bodyclass: "boldclass",
      // },
      //   {
      //     header: "InTransist Qty",
      //     field: "InTransist",
      //     bodyclass: "boldclass",
      // },
    ];
    function SaveButton() {
      debugger;
      if (BlockPopup.value.BlockReason == "") {
        toast.add({
          severity: "info",
          summary: "Enter Reason",
          detail: "",
          life: 3000,
        });
      } else {
        BlockPopup.value.Visible = false;
        Deletemodel.value = true;
      }
    }
    const UOMOnChange = (UOMId) => {

      if (UOMId) {
        debugger;
        if (StockAdjData.value.UnitId == UOMId && CurrentUOM == "PurchaseUnit") {
          StockAdjData.value.StockInHand = String(
            Number(StockAdjData.value.StockInHand) * Number(StockAdjData.value.ConversionFactor)
          );
          CurrentUOM = "SalesUnit";
        } else if (
          StockAdjData.value.OrderUnitId == UOMId &&
          CurrentUOM == "SalesUnit"
        ) {
          StockAdjData.value.StockInHand = String(
            Number(StockAdjData.value.StockInHand) / Number(StockAdjData.value.ConversionFactor)
          );
          CurrentUOM = "PurchaseUnit";
        }
      } else {
        ItemData.UOMName = "";
      }
    };

    watch(
      () => StockAdjData.value.RoomId,
      () => {
        // alert('s')
        getrackbyroomid();
      }
    );
    watch(
      () => StockAdjData.value.RowId,
      () => {
        getboxbyrowid();
      }
    );
    watch(
      () => StockAdjData.value.RackId,
      () => {
        getrowbyrackid();
      }
    );
    watch(
      () => StockAdjData.value.Batch,
      () => {
        getroombystoreid();
      }
    );

    let selectedItems = ref([]);
    function SelectItem(value) {
      debugger;
      selectedItems.value = value;
    }

    const CrystalReportPopup = ref(false);
    const ParameterValues = ref({
      Id: "0",
      BranchId: 0,
      HospitalId: 0,
    });

    const PrintType = ref({
      Type: "T",
      FormId: 106,
      HeaderTitle: "Item barcode",
      ModuleId: 3,
    });

    const printBarcodes = () => {
      if (selectedItems.value.length != 0) {

        const barcodenos = selectedItems.value
          .map(item => item["BarCodeNo"])
          .join(',');

        alert(barcodenos);

        CrystalReportPopup.value = true;
        ParameterValues.value.Id = barcodenos;
        PrintType.value.FormId = 107;
      } else {
        toast.add({
          severity: "warn",
          summary: "No Items Selected",
          detail: "Please select at least one item to print barcodes.",
          life: 3000,
        });
      }
    };

    const hidepopup = () => {
      CrystalReportPopup.value = false;
    };

    function getExpiryDateStyle(expiryDate: string) {
      if (!expiryDate || expiryDate === '01 Jan 1900' || expiryDate === '01-01-0001' || expiryDate === '01-01-1900' || expiryDate === '-') {
        return {};
      }

      try {
        // Handle both "DD MMM YYYY" and "DD-MM-YYYY" formats
        let expiry: Date;
        if (expiryDate.includes(' ')) {
          // Format like "31 Aug 2025"
          expiry = new Date(expiryDate);
        } else {
          // Format like "31-08-2025"
          const [day, month, year] = expiryDate.split('-').map(Number);
          expiry = new Date(year, month - 1, day);
        }

        const today = new Date();
        const diffTime = expiry.getTime() - today.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays < 0) {
          return { color: '#dc3545', fontWeight: 'bold' }; // Red for expired
        } else if (diffDays <= 90) {
          return { color: '#fd7e14', fontWeight: 'bold' }; // Orange for within 90 days
        }
        return {};
      } catch (error) {
        return {};
      }
    }

    function getExpiryMessage(expiryDate: string) {
      if (!expiryDate || expiryDate === '01 Jan 1900' || expiryDate === '01-01-0001' || expiryDate === '01-01-1900' || expiryDate === '-') {
        return '';
      }

      try {
        // Handle both "DD MMM YYYY" and "DD-MM-YYYY" formats
        let expiry: Date;
        if (expiryDate.includes(' ')) {
          // Format like "31 Aug 2025"
          expiry = new Date(expiryDate);
        } else {
          // Format like "31-08-2025"
          const [day, month, year] = expiryDate.split('-').map(Number);
          expiry = new Date(year, month - 1, day);
        }

        const today = new Date();
        const diffTime = expiry.getTime() - today.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays < 0) {
          return `Expired ${Math.abs(diffDays)} days ago`;
        } else if (diffDays <= 90) {
          return `Expires in ${diffDays} days`;
        }
        return '';
      } catch (error) {
        return '';
      }
    }

    return {
      getExpiryDateStyle,
      getExpiryMessage,
      clearFilter,
      applyFilter,
      LoadItemConfigurationfilter,
      FilterOpData,
      Filterdata,
      getrackbyroomid,
      Loadloaction,
      sidebarMinwidth,
      QtyChange,
      DispExp,
      Batchheaders,
      ItemDetails,
      BoxOnChange,
      SubmitStocAdjustment,
      TotOption,
      RoomOnChange,
      RackOnChange,
      RowOnChange,
      StockAdjData,
      StockAdjOpData,
      Batchitems,
      StoreId,
      LoadItemDetails,
      loading,
      ItemData,
      itemid,
      Chartdata,
      options,
      active,
      placement,
      slidervalue,
      location,
      reason,
      date,
      AvailQty,
      Qty,
      items,
      sidebarwidth,
      stockAdjust,
      showDetails,
      stockForm,
      showTable,
      headers,
      items1,
      globalFilterFields,
      loading1,
      filteredColumns,
      BreakUpDetails,
      ViewDetails,
      filters,
      BreakUpitems,
      ItemBreakUpTable,
      Deletemodel,
      contentdel,
      IsConfirm,
      IsBlock,
      datablock,
      ItemBreakUPHeaders,
      BlockPopup,
      SaveButton,
      itemsBatchNoList,
      getrowbyrackid,
      getboxbyrowid,
      FieldDisable,
      filterBatchNo,
      itemsBarCodeNoList,
      UOMOnChange,
      SelectItem,
      selectedItems,
      printBarcodes,
      PrintType,
      CrystalReportPopup,
      ParameterValues,
      hidepopup
    };
  },
});
</script>

<style lang="scss">
.expiry-message {
  font-size: 0.75rem;
  font-style: italic;
  margin-top: 2px;
}

.line {
  width: 100%;
  height: 4px;
  background-color: #0148e2;
}

.Details-container {
  width: 100%;
  max-height: 87vh;
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
  box-sizing: border-box;

  .high-val {
    font-size: 12px;
    color: blue;
  }

  .sidbar-label {
    font-size: 12px;
    color: #999999;
  }

  .sidbar-val {
    font-size: 12px;
    color: #444444;
    text-align: right;
  }

  .closed {
    text-align: end;
  }

  .sub-heading {
    text-align: left;
    padding: 15px 0px;
    font-weight: 500;
    font-size: 13px;
    color: #000000;
  }

  .chartbar {
    background-color: rgb(255, 255, 255);
  }

  .Avail-box:hover {
    background-color: #28c840;

    .Avail-select,
    .Avail-select1 {
      background-color: #1c47d9;
    }

    .Avail-count1 {
      color: #ffffff;
    }

    .Avail-count {
      color: #ffffff;
    }

    .Avail-content {
      color: #ffffff;
    }
  }

  .Avail-box {
    cursor: pointer;
    padding: 10px 5px;
    border-radius: 10px;

    .Avail-select {
      border-radius: 50%;
      margin: 5px;
      margin-left: 0px;
      width: 9px;
      height: 8px;
      background-color: #adaadb;
    }

    .Avail-select1 {
      border-radius: 50%;
      margin: 5px;
      margin-left: 0px;
      width: 17px;
      height: 8px;
      background-color: #adaadb;
    }

    .Avail-count1 {
      font-size: 20px;
      color: #000000;
      text-align: center;
    }

    .Avail-count {
      font-size: 15px;
      color: #000000;
      text-align: center;
    }

    .Avail-content {
      font-size: 10px;
      color: #999999;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // display: -webkit-box;
      // -webkit-line-clamp: 2;
      // line-clamp: 2;
      // -webkit-box-orient: vertical;
    }
  }

  .i-count {
    background-color: #28c840;
    border-radius: 6px;
  }

  .I-heading {
    font-size: 15px;
    text-align: left;
    padding: 10px;
    font-weight: 600;
    color: #ffffff;
  }

  .close {
    text-align: end;
  }

  .tablet-id {
    font-weight: 200;
    font-size: 12px;
    color: #999999;
  }

  .tablet-name {
    font-weight: 300;
    font-size: 15px;
    color: #000000;
    font-weight: 500;
    letter-spacing: 1px;
  }

  .I-img {
    margin: 10px;
    width: 30px;
  }

  .d-heading {
    text-align: left;
    font-size: 13px;
    font-weight: 600;
    color: #000000;
  }

  .v-details {
    text-align: right;
    font-size: 13px;
    font-weight: 400;
    color: #3096ff;
  }
}

.txt-blue-sm {
  font-size: 12px;
  color: #3096ff;
}

.p-sidebar-header-content {
  width: 100%;
}

.sidebar-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .pi {
    font-size: 14px !important;
  }
}

.availabiltybar .p-progressbar {
  height: 0.65rem;
}

.availabiltybar .p-progressbar-label {
  display: none !important;
}

.availabiltybar .p-progressbar .p-progressbar-value {
  background: #0148e2;
}

.banbtndiv {
  color: rgb(245, 4, 4);
}
</style>

<style lang="scss" scoped>
.stock-form {
  margin-left: 15px;
  max-height: 87vh;
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

.itemlinkreqbg {
  width: 100%;
  padding: 7px;
  background-color: #d6e7fb;
  border-radius: 5px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 5px;

  .itemcount {
    font-weight: 600;
    margin-right: 5px;
  }

  p {
    font-size: 12px;
  }

  img {
    width: 20px;
  }
}

.itemlinkstorebg {
  width: 100%;
  padding: 7px;
  background-color: #f4dcdb;
  border-radius: 5px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 5px;

  .itemcount {
    font-weight: 600;
    margin-right: 5px;
  }

  p {
    font-size: 12px;
  }

  img {
    width: 20px;
  }
}

.itembatchmfts {
  font-size: 14px;
  font-weight: 500;
}

.stock-table td {
  font-size: 12px;
}

.stock-table th {
  font-size: 14px;
}

.breakup-table {
  margin-left: 3%;
  width: 100%;
}

.free-item {
  color: palevioletred;
  /* Or any other styling you prefer */
}

.Block-item {
  color: rgb(163, 104, 3);
}

.itemsetailtable {
  width: 75%;
  max-height: 87vh;
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}
</style>
